var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.tenantError && !_vm.tenantLoading),expression:"!tenantError && !tenantLoading"}],ref:"companionWidgetRoot",staticClass:"contents"})
}
var staticRenderFns = []

export { render, staticRenderFns }